import * as amplitude from '@amplitude/analytics-browser';

export const initAmplitude = () => {
  try {
    amplitude.init(process.env.REACT_APP_AMPLITUDE);
  } catch (error) {
    console.error({
      Error: error
    });
  }
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  try {
    amplitude.track(eventType, eventProperties);
  } catch (error) {
    console.error({
      Error: error
    });
  }
};
